import { application } from "./application"

import AutoSubmitController from "./auto_submit_controller"
import DropdownController from "./dropdown_controller"
import FrameResetController from "./frame_reset_controller"
import MarkdownEditorController from "./markdown_editor_controller"
import NewsletterController from "./newsletter_controller"
import PopupController from "./popup_controller"
import ThingArrayController from "./thing_array_controller"
import ThingSelectionController from "./thing_selection_controller"

application.register("auto-submit",     AutoSubmitController)
application.register("dropdown",        DropdownController)
application.register("frame-reset",     FrameResetController)
application.register("markdown-editor", MarkdownEditorController)
application.register("newsletter",      NewsletterController)
application.register("popup",           PopupController)
application.register("thing-array",     ThingArrayController)
application.register("thing-selection", ThingSelectionController)
